module.exports = __webpack_public_path__ + "static/media/JustFleckless–10Navy.b9bf7c7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/JustFleckless–10Navy.jpg
// module id = 22
// module chunks = 0